import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// Descomentar para selección múltiple
//import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import { useTranslation } from 'react-i18next';


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) { 
  // console.log('array', Object.values(array));
  const stabilizedThis = Object.values(array).map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, titulosColumnas } = props;
  /* Descomentar junto con el componente checkbox para selección múltiple
  const { onSelectAllClick, numSelected, rowCount } = props; */
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {/* <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          /> */}
        </TableCell>
        {titulosColumnas.map((tituloColumna) => (
          <TableCell
            key={tituloColumna.id}
            align={'left'}
            padding={(tituloColumna.label === 'Número de cuenta' || tituloColumna.label === 'Account number') ? 'none' : 'default'}
            sortDirection={orderBy === tituloColumna.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === tituloColumna.id}
              direction={orderBy === tituloColumna.id ? order : 'asc'}
              onClick={createSortHandler(tituloColumna.id)}
            >
              {tituloColumna.label}
              {orderBy === tituloColumna.label ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, tituloTabla } = props;
  const { t } = useTranslation(['translation', 'pagos']);

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} 
          {numSelected === 1
            ? t('pagos:seleccioncta')
            : t('pagos:ctasseleccion')}
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          {tituloTabla}
        </Typography>
      )}

    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableCell: {
    color: "#fe7c2e",
  },
}));

export default function CuentasServicio(props) {
  const { tituloTabla, titulosColumnas, cuentasServicio, estatusCuentas, 
    onSelectedAccount, onSelectAllAccounts, captchaValido, cuentaParaPago } = props;
  const ctasFiltradasEstado = Object.values(cuentasServicio)
                          .filter((cuenta) => cuenta.accountStatus === estatusCuentas)
                          .map((cuenta) => cuenta);
  const cantidadCuentas = ctasFiltradasEstado.length;
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('No. de Cuenta');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(3);
  const { t } = useTranslation(['translation', 'pagos']);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  React.useEffect(() => {
    // console.log("[cuentas] captchaValido", captchaValido);
    if (!captchaValido && selected.length > 0) {
      setSelected([]);
      return;
    }
    if(selected.length > 0) {
      // console.log('selected', selected)
      // console.log('cuentaParaPago', cuentaParaPago[0].accountNumber)
      if (!selected.includes(cuentaParaPago[0].accountNumber)) {
        setSelected([]);
      }
    } 
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = ctasFiltradasEstado.map((n) => n.accountNumber);
      setSelected(newSelecteds);
      onSelectAllAccounts(event, ctasFiltradasEstado);
      return;
    }
    setSelected([]);
    onSelectAllAccounts(event, [], estatusCuentas);
  };

  const handleOneSelection = (event, numero_cuenta) => {
    let newSelected = [];
    // console.log('numero_cuenta', numero_cuenta);
    newSelected.push(numero_cuenta);
    setSelected(newSelected);
    onSelectedAccount(event, numero_cuenta);
  }

/* #
   # Para manejar selección múltiple de cuentas
   # 
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) { // No existe
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) { // Es el primero
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) { //Es el último
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) { // Existe, entre el primero y último
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
    onSelectedAccount(event, name);
  };
*/

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, cantidadCuentas - page * rowsPerPage);
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar 
          numSelected={selected.length}
          tituloTabla={tituloTabla}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="a dense table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={cantidadCuentas}
              titulosColumnas={titulosColumnas}
            />
            <TableBody>
              {stableSort(ctasFiltradasEstado, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.accountNumber);
                  const fechaFormateada = row.lastPayment !== '' ? new Date(row.lastPayment) : '';
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleOneSelection(event, row.accountNumber)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.accountNumber}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Radio
                          className={tituloTabla.includes('Cancel') ? classes.tableCell : null}
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell className={tituloTabla.includes('Cancel') ? classes.tableCell : null} component="th" id={labelId} scope="row" padding="none">
                        {row.accountNumber}
                      </TableCell>
                      <TableCell className={tituloTabla.includes('Cancel') ? classes.tableCell : null}>{row.productName}</TableCell>
                      <TableCell className={tituloTabla.includes('Cancel') ? classes.tableCell : null}>{t('pagos:'+row.accountStatus.toLowerCase())}</TableCell>
                      <TableCell className={tituloTabla.includes('Cancel') ? classes.tableCell : null}>{row.customerName}</TableCell>
                      <TableCell className={tituloTabla.includes('Cancel') ? classes.tableCell : null}>{fechaFormateada !== '' ? fechaFormateada.toLocaleDateString('en-GB') : ''}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 33 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage={t('pagos:registros')}
          rowsPerPageOptions={[3, 6, 15]}
          component="div"
          count={cantidadCuentas}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
